import { fetchJWTToken, saveAppToken } from './login';
import {LOGINSTATE_LOGOUT } from './login'

export const DONE_REFRESHING_TOKEN =    'DONE_REFRESHING_TOKEN'
export const REFRESHING_TOKEN_ERROR =   'REFRESHING_TOKEN_ERROR'
export const REFRESHING_TOKEN =         'REFRESHING_TOKEN'
export const AUTHENTICATION_ADDUPDATE_TOKEN = 'AUTHENTICATION_ADDUPDATE_TOKEN'



export function refreshToken (dispatch)  {

    var freshTokenPromise = dispatch(fetchJWTToken())
        .then(t => {
            dispatch({
                type:DONE_REFRESHING_TOKEN
            });

            dispatch(saveAppToken(t.token));

            return t.token ? Promise.resolve(t.token) : Promise.reject({
                message: 'could not refresh token'
            });
        })
        .catch(e => {
            
            dispatch({type: REFRESHING_TOKEN_ERROR});
            dispatch({type: LOGINSTATE_LOGOUT});
            return Promise.reject(e);
        });

    dispatch({
        type: REFRESHING_TOKEN,        
        freshTokenPromise
    });

    return freshTokenPromise;
}